import { faSpinnerThird } from '@fortawesome/pro-solid-svg-icons';
import PropTypes from 'prop-types';
import { Fragment } from 'react';

import { Icon } from '../Icons';

import './styles/buttonSmallStyles.css';
import './styles/buttonStyles.css';

const sizes = {
  small: 'button-small',
  default: '',
};

const ButtonBase = ({
  children,
  className,
  disabled,
  isLoading,
  size,
  ...rest
}) => (
  <button
    className={`${className} ${sizes[size] || ''}`}
    disabled={disabled || isLoading}
    type="submit"
    {...rest}
  >
    {isLoading && (
      <Fragment>
        <Icon icon={faSpinnerThird} spin />{' '}
      </Fragment>
    )}
    {children}
  </button>
);

ButtonBase.defaultProps = {
  className: '',
  disabled: false,
  isLoading: false,
  size: 'default',
};

ButtonBase.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  isLoading: PropTypes.bool,
  size: PropTypes.oneOf(['default', 'small']),
};

export default ButtonBase;
